var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThrone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 36,
    viewBox: "0 0 47 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.888 15.5273C41.508 15.2412 41.0464 15.0573 40.556 14.9964C40.0655 14.9354 39.566 15.0001 39.1143 15.1829L30.7103 18.5526L25.8273 10.615C25.5939 10.2445 25.2558 9.93628 24.8473 9.72188C24.4389 9.50748 23.9747 9.39453 23.5021 9.39453C23.0295 9.39453 22.5653 9.50748 22.1568 9.72188C21.7484 9.93628 21.4102 10.2445 21.1768 10.615L16.2939 18.5526L7.88981 15.1829C7.43723 15.0003 6.93705 14.9356 6.44582 14.996C5.95458 15.0564 5.49188 15.2396 5.11002 15.5247C4.72816 15.8098 4.44237 16.1856 4.28496 16.6095C4.12755 17.0334 4.10479 17.4886 4.21926 17.9236L8.4379 34.1431C8.51856 34.4571 8.66909 34.7531 8.88035 35.0131C9.09162 35.2731 9.35922 35.4917 9.66695 35.6557C10.0836 35.8806 10.5599 35.9996 11.0455 36.0002C11.2815 35.9998 11.5163 35.9695 11.743 35.9103C19.4326 33.9933 27.5549 33.9933 35.2445 35.9103C35.9466 36.0767 36.6933 35.9852 37.3206 35.6557C37.6302 35.4938 37.8993 35.2758 38.1108 35.0155C38.3223 34.7551 38.4718 34.4581 38.5496 34.1431L42.7849 17.9236C42.8981 17.4885 42.8741 17.0335 42.7156 16.6101C42.5571 16.1866 42.2704 15.8116 41.888 15.5273Z",
    fill: "#FFAA00"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 4",
    cx: 23.5013,
    cy: 5.36976,
    rx: 5.52966,
    ry: 5.36976,
    fill: "#FFAA00"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 7",
    cx: 23.5008,
    cy: 24.166,
    rx: 4.14725,
    ry: 4.02732,
    fill: "#BE9502"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 5",
    cx: 43.5459,
    cy: 14.0963,
    rx: 3.45604,
    ry: 3.3561,
    fill: "#FFAA00"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 6",
    cx: 3.45604,
    cy: 14.0963,
    rx: 3.45604,
    ry: 3.3561,
    fill: "#FFAA00"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 8",
    cx: 13.1332,
    cy: 26.1758,
    rx: 2.07362,
    ry: 2.01366,
    fill: "#BE9502"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 9",
    cx: 33.8695,
    cy: 26.1758,
    rx: 2.07362,
    ry: 2.01366,
    fill: "#BE9502"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrone);
export default __webpack_public_path__ + "static/media/throne.50c679b792960bc37497a422f072eb6c.svg";
export { ForwardRef as ReactComponent };